/* WaniTas — kleine interacties: galerij, varianten, aantal */
document.addEventListener('click', function (e) {
  var thumb = e.target.closest('.wt-thumbs button');
  if (thumb) {
    var main = document.getElementById('wt-main-image');
    if (main) main.src = thumb.dataset.src;
    thumb.parentNode.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  }

  var opt = e.target.closest('[data-option-index]');
  if (opt) {
    opt.parentNode.querySelectorAll('[data-option-index]').forEach(function (b) {
      b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false');
    });
    opt.classList.add('is-active'); opt.setAttribute('aria-pressed', 'true');
    syncVariant(opt.closest('form'));
  }

  var qty = e.target.closest('[data-qty]');
  if (qty) {
    var input = qty.parentNode.querySelector('input');
    input.value = Math.max(1, parseInt(input.value, 10) + parseInt(qty.dataset.qty, 10));
  }
});

function syncVariant(form) {
  if (!form) return;
  var select = form.querySelector('[data-variant-select]');
  if (!select) return;
  var chosen = Array.from(form.querySelectorAll('[data-option-index].is-active'))
    .sort(function (a, b) { return a.dataset.optionIndex - b.dataset.optionIndex; })
    .map(function (b) { return b.dataset.value; }).join(' / ');
  Array.from(select.options).forEach(function (o) {
    if (o.textContent.trim().indexOf(chosen) === 0) select.value = o.value;
  });
}
